"use client";

import Hyperlink from "../ui/hyperlink";

interface CtaData {
    primary: {
        text: string;
        href: string;
    };
    secondary: {
        text: string;
        modalTitle: string;
    };
}

interface Props {
    title?: string;
    description?: string;
    onModalOpen?: (modalTitle?: string) => void;
    cta?: CtaData;
}

const PreFooter = ({ title, description, onModalOpen, cta }: Props) => {
    return (
        <div className="pre-footer section-padding-top-bottom">
            <div className="container custom-container">
                <div className="bg-color-pf-gradient section-padding-top-bottom px-90">
                    <div className="container custom-container">
                        <div className="row g-4 justify-content-between">
                            <div className="col-lg-8 col-xl-7 col-xxl-6">
                                <h2 className="text-color-primary">
                                    {title ?? "Ready to turn vision into action?"}
                                </h2>
                            </div>
                            <div className="col-lg-4 col-xl-5 col-xxl-6">
                                <div className="desilo-about__content style-2">
                                    <p className="text-color-primary">
                                        {description ?? "Collaborate with experts to define clear goals and build actionable strategies for success."}
                                    </p>
                                    <div className="d-flex flex-column">
                                        <Hyperlink
                                            href={cta?.primary.href || "https://calendly.com/parthik/30min"}
                                            target="_blank"
                                            className="text-color-primary d-block cursor-pointer"
                                        >
                                            {cta?.primary.text || "Book a consultation call"}
                                        </Hyperlink>
                                        <Hyperlink
                                            variant="modal"
                                            onModalOpen={onModalOpen}
                                            modalTitle={cta?.secondary.modalTitle || "Request a consultation"}
                                            className="text-color-primary d-block cursor-pointer"
                                        >
                                            {cta?.secondary.text || "Request a consultation"}
                                        </Hyperlink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PreFooter;